import { CellProps } from 'react-table'
import { AtendimentoView } from '../../../../atendimento/core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

const personalAtendimentosColumns = (t: TFunction): ReadonlyArray<TableColumn<AtendimentoView>> => [
  // Paciente com o protocolo como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoView>({
    id: 'paciente',
    useQueryRequest,
    fields: [
      { field: 'paciente', label: t('cols.paciente') },
      { field: 'protocolo', label: t('cols.protocolo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoView>) => (
      <StackedCell primary={row.original.paciente?.nome} secondary={row.original.protocolo} />
    ),
  }),
  // Tipo de atendimento com a especialidade como apoio.
  sortableColumn<AtendimentoView>({
    id: 'tipo',
    cellWidth: '200px',
    useQueryRequest,
    fields: [
      { field: 'tipo', label: t('cols.tipo') },
      { field: 'especialidade', label: t('cols.especialidade') },
    ],
    Cell: ({ row }: CellProps<AtendimentoView>) => (
      <StackedCell primary={row.original.tipo} secondary={row.original.especialidade?.nome} />
    ),
  }),
  sortableColumn<AtendimentoView>({
    id: 'estado.nome',
    cellWidth: '180px',
    useQueryRequest,
    fields: [{ field: 'estado.nome', label: t('cols.status') }],
    Cell: ({ row }: CellProps<AtendimentoView>) => (
      <StackedCell primary={row.original.estado?.nome} />
    ),
  }),
  // Instituição com o CNPJ como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoView>({
    id: 'empresa.nomeFantasia',
    cellWidth: '240px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'empresa.nomeFantasia', label: t('empresa.label') },
      { field: 'empresa.cnpj', label: t('cols.documento.cnpj') },
    ],
    Cell: ({ row }: CellProps<AtendimentoView>) => (
      <StackedCell
        tabular
        primary={row.original.empresa?.nomeFantasia}
        secondary={row.original.empresa?.cnpj}
      />
    ),
  }),
  // Data da solicitação (ordem padrão: mais recente primeiro) com o profissional como apoio.
  sortableColumn<AtendimentoView>({
    id: 'solicitacao',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'solicitacao', label: t('cols.data') },
      { field: 'responsavel.nome', label: 'Profissional' },
    ],
    Cell: ({ row }: CellProps<AtendimentoView>) => (
      <StackedCell
        tabular
        primary={row.original.solicitacaoFormatada}
        secondary={row.original.responsavel?.nome}
      />
    ),
  }),
]

export { personalAtendimentosColumns }
